import Cookies from "js-cookie";
import {
  AddToWishlist,
  RemoveFromWishlist,
} from "../../State/actions/WishlistActions";
import { globalSwalFunction } from "./globalSwal";

// Wishlist Add and remove...
export const AddToWishListHandler = (
  productvarientId,
  productId,
  categoryId,
  productName,
  productImage,
  mrp,
  sellingPrice,
  haveVariations,
  // Updated State,
  setShowWishlist,
  setshowHideLoginForm,
  //   .......
  dispatch
) => {
  if (
    Cookies.get("ID") &&
    Cookies.get("CONTACT_NUMBER") &&
    Cookies.get("CUSTOMER_NAME")
  ) {
    setShowWishlist(true);
    dispatch(
      AddToWishlist(
        productvarientId,
        productId,
        categoryId,
        productName,
        productImage,
        mrp,
        sellingPrice,
        haveVariations
      )
    );
    // This function created for fire toaster with swal (Third party Dependency)
    setTimeout(()=>{
      globalSwalFunction(
        "Product added to Wishlist",
        '<i class="fas fs-5 fa-check-circle text-success "></i>'
      );
    },300)
    setShowWishlist(false);
  } else {
    setShowWishlist(false);
    setshowHideLoginForm(true);
  }
};

export const RemoveWishListCartHandler = (
  wishlistId,
  setShowWishlist,
  dispatch
) => {
  if (wishlistId) {
    setShowWishlist(true);
    dispatch(RemoveFromWishlist(Cookies.get("ID"), wishlistId));
    // This function created for fire toaster with swal (Third party Dependency)
    globalSwalFunction(
      "Product removed from Wishlist",
      '<i class="fas fs-5 fa-check-circle text-success "></i>'
    );
    setShowWishlist(false);
  } else {
    setShowWishlist(true);
  }
};
